module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00341.5ca1812e.jpg";